/** Per-app local logout marker — blocks silent SSO re-login until user clicks Sign In. */
export const APP_LOGGED_OUT_KEY = `${(
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "niadit"
).trim()}_logged_out`;
